import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Scalefutureai() {
  return (
    <section className="scale_future_ai p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Advanced <span>Vendor Portal Development</span> Services for
              Seamless Management
            </h2>
            <div className="vendor-img mt-3 mt-md-0">
              <StaticImage
                src="../../images/services-usa/vendor-portal/advanced-portal-services.webp"
                alt="tekrevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={760}
                height={493}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-1 mt-3 mt-md-0"
          >
            <p>
              Our supplier web portal solution streamlines your supplier
              relationships through supplier onboarding, policy administration,
              and RFP management, ensuring that your company's supplier
              processes run smoothly and efficiently.
            </p>
            <p>
              <strong>
                We offer a range of vendor portals that come with different
                features, including:
              </strong>
            </p>
            <ul>
              <li>Effortless supplier registration for seamless onboarding</li>
              <li>SLA performance metrics to monitor supplier efficiency</li>
              <li>Policies and procedures for consistent communication</li>
              <li>
                Automated notifications and updates to keep everyone aligned
              </li>
              <li>RFP management tools for smooth procurement processes</li>
              <li>Custom workflows to adapt to your specific business needs</li>
            </ul>
            <p>
              We have a dedicated team of consultants who will assist businesses
              with collaborative information processing and management, to
              improve vendor relationships while lowering costs and enhancing
              company efficiency.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Scalefutureai;
